import { render, staticRenderFns } from "./TabResultat.vue?vue&type=template&id=26f60855&scoped=true&"
import script from "./TabResultat.vue?vue&type=script&lang=js&"
export * from "./TabResultat.vue?vue&type=script&lang=js&"
import style0 from "./TabResultat.vue?vue&type=style&index=0&id=26f60855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f60855",
  null
  
)

export default component.exports